// 注意 添加响应式时也要Object.frezze处理一下  否则影响性能  组件对象不应作为响应式绑定在Props上
// 定义Stable的列  [注: 此页面不允许存在业务逻辑]

import AlarmRecordCarrier from '@/config/table/widgets/AlarmRecordCarrier'
import AlarmObject from '@/config/table/widgets/AlarmObject'
import Carrier from '@/config/table/widgets/Carrier'
import Sample from '@/config/table/widgets/Sample'
import AlarmReason from '@/config/table/widgets/AlarmReason'
import { pPlatformUser } from '@/config/power/power'

// 报警记录监测点
export const colAlarmRecordCarrier = {
  index: 'carrierName',
  title: $t('integration.monitoring_point'),
  tooltip: false,
  component: AlarmRecordCarrier
}

// 客户
export const colCustomer = {
  index: 'sceneName',
  title: $t('integration.customer'),
  tooltip: true,
  hidden: pPlatformUser
}

// 组织单元 架构
export const colScene = {
  title: $t('integration.organizational_unit'),
  tooltip: true,
  index: 'structureName'
}

// 层级
export const colLayer = {
  title: $t('integration.hierarchy'),
  tooltip: true,
  index: 'hierarchy'
}

// 报警对象
export const colAlarmObject = {
  index: 'alarmObject',
  title: $t('integration.alarm_object'),
  tooltip: true,
  component: AlarmObject
}

// 创建时间
export const colCreateTime = {
  title: $t('integration.creation_time'),
  dataType: 'time',
  tooltip: true,
  index: 'alarmTime'
}

// 监测点
export const colCarrier = {
  index: 'keycode',
  title: $t('integration.monitoring_point'),
  component: Carrier,
  tooltip: true,
  width: '300px'
}

// 取样值
export const colSample = {
  index: 'sampleValue',
  title: $t('integration.sampling'),
  component: Sample,
  width: '310px'
}

// 报警原因
export const colAlarmReason = {
  index: 'alarmReason',
  title: $t('integration.alarm_reason'),
  component: AlarmReason
}
